/* ============================================================
   EDGE Performance — edge.js
   Nav scroll, mobile menu, scroll animations, form handling
   ============================================================ */

(function () {
  'use strict';

  /* ── 1. FIXED NAV BACKGROUND STATE ────────────────────── */
  const nav = document.querySelector('.site-nav');

  function updateNavBackground() {
    if (nav) nav.classList.toggle('scrolled', window.scrollY > 60);
  }

  if (nav) {
    updateNavBackground();
    window.addEventListener('scroll', updateNavBackground, { passive: true });
  }

  /* ── 2. ACCESSIBLE MOBILE MENU ─────────────────────────── */
  const hamburger = document.querySelector('.nav-hamburger');
  const mobileMenu = document.querySelector('.mobile-menu');
  const body = document.body;

  function setMobileMenu(isOpen, restoreFocus) {
    if (!hamburger || !mobileMenu) return;
    mobileMenu.classList.toggle('open', isOpen);
    mobileMenu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    hamburger.classList.toggle('open', isOpen);
    hamburger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    hamburger.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
    body.style.overflow = isOpen ? 'hidden' : '';

    if (isOpen) {
      const firstLink = mobileMenu.querySelector('a');
      if (firstLink) window.requestAnimationFrame(function () { firstLink.focus(); });
    } else if (restoreFocus) {
      hamburger.focus();
    }
  }

  if (hamburger && mobileMenu) {
    mobileMenu.setAttribute('aria-hidden', 'true');
    hamburger.addEventListener('click', function () {
      setMobileMenu(!mobileMenu.classList.contains('open'), false);
    });
    mobileMenu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () { setMobileMenu(false, false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileMenu.classList.contains('open')) {
        setMobileMenu(false, true);
      }
    });
  }

  /* ── 3. SCROLL FADE-IN ANIMATIONS ─────────────────────── */
  const fadeTargets = document.querySelectorAll(
    '.section-eyebrow, .section-headline, .section-sub, ' +
    '.why-card, .bh-left, .bh-right, .discipline-card, ' +
    '.how-step, .equipment-card, .pricing-card, .profiling-card, ' +
    '.portal-feature, .edu-topics, .edu-card, .pm-window, ' +
    '.trust-item, .equipment-philosophy, .cta-inner, ' +
    '.service-pathway-card, .profile-tech-point, .education-strip-links a'
  );

  if ('IntersectionObserver' in window && fadeTargets.length > 0) {
    // Add initial hidden state via JS (not CSS) so no-JS still works
    fadeTargets.forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.55s ease, transform 0.55s ease';
    });

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // Stagger siblings in the same grid
          const siblings = entry.target.parentElement
            ? Array.from(entry.target.parentElement.children).filter(
                function (c) { return c === entry.target || c.style.opacity === '0'; }
              )
            : [];
          const idx = siblings.indexOf(entry.target);
          const delay = Math.min(idx * 60, 240);

          setTimeout(function () {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
          }, delay);

          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -40px 0px'
    });

    fadeTargets.forEach(function (el) { observer.observe(el); });
  }

  /* ── 4. SMOOTH SCROLL FOR ANCHOR LINKS ─────────────────── */
  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      const id = link.getAttribute('href').slice(1);
      const target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();

      // Close mobile menu if open
      if (mobileMenu && mobileMenu.classList.contains('open')) setMobileMenu(false, false);

      const headerH = nav ? nav.offsetHeight : 0;
      const top = target.getBoundingClientRect().top + window.scrollY - headerH - 16;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    });
  });

  /* ── 5. MEMBERSHIP / PRICING TOGGLE ACTIVE STATE ────────── */
  // If we later add monthly/seasonal toggle, the hook is here
  // const toggles = document.querySelectorAll('[data-billing-toggle]');

  /* ── 6. SHOPIFY FORM + CUSTOM CONVERSION HANDLING ─────── */
  document.querySelectorAll('form[data-edge-form], #EdgeMembershipRequestV5, #EdgeBladeNotesSignup').forEach(function (form) {
    form.addEventListener('submit', function () {
      const btn = form.querySelector('button[type="submit"]');
      if (btn) { btn.dataset.originalLabel = btn.textContent; btn.textContent = 'Sending…'; btn.disabled = true; }
    });
  });

  document.querySelectorAll('[data-edge-cta]').forEach(function (el) {
    el.addEventListener('click', function () {
      document.documentElement.setAttribute('data-edge-last-cta', el.getAttribute('data-edge-cta') || '');
    });
  });

  document.querySelectorAll('[data-edge-conversion]').forEach(function (el) {
    const eventName = el.getAttribute('data-edge-conversion');
    if (!eventName || el.dataset.sent === 'true') return;
    if (typeof window.TriplePixel === 'function') {
      window.TriplePixel('custom', eventName, {
        pageUrl: window.location.href,
        pageType: document.body.className,
        source: new URLSearchParams(window.location.search).get('utm_source') || '',
        medium: new URLSearchParams(window.location.search).get('utm_medium') || '',
        campaign: new URLSearchParams(window.location.search).get('utm_campaign') || '',
        content: new URLSearchParams(window.location.search).get('utm_content') || ''
      });
      el.dataset.sent = 'true';
    }
  });

  /* ── 7. MOBILE STICKY BAR SCROLL TRIGGER ─────────────────
     Hide sticky bar when near top of page; show once scrolled             */
  const stickyBar = document.querySelector('.mobile-sticky');
  if (stickyBar) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 300) {
        stickyBar.style.opacity = '1';
        stickyBar.style.pointerEvents = 'auto';
      } else {
        stickyBar.style.opacity = '0';
        stickyBar.style.pointerEvents = 'none';
      }
    }, { passive: true });
    // Initial state
    stickyBar.style.opacity = '0';
    stickyBar.style.transition = 'opacity 0.3s ease';
    stickyBar.style.pointerEvents = 'none';
  }

  /* ── 8. ACTIVE NAV LINK HIGHLIGHTING ─────────────────────
     Highlight nav link whose section is currently in view               */
  const navLinks = document.querySelectorAll('.nav-links a[href^="#"]');
  const sections = Array.from(navLinks).map(function (l) {
    return document.querySelector(l.getAttribute('href'));
  }).filter(Boolean);

  if (navLinks.length && sections.length && 'IntersectionObserver' in window) {
    const navObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          const id = '#' + entry.target.id;
          navLinks.forEach(function (l) {
            l.classList.toggle('active', l.getAttribute('href') === id);
          });
        }
      });
    }, { threshold: 0.35 });

    sections.forEach(function (s) { navObs.observe(s); });
  }

})();
